import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { common } from "..";
import PropTypes from "prop-types";
import numeral from "numeral";
import {
  clearEntriesParameters,
  getEntriesRead
} from "../../../../store/actions/reports/balance/ledger";
import { ledgerDetailsConversion } from "./conversions";
import { getDraftIdFromOriginalEntry } from "../../../../store/actions/precog";
import { useNavigate } from "react-router-dom";

const ReportLedgerSheet = ({
  objDetails,
  setDataReport,
  setSelectedSearch,
  paramsFromUrl,
  setCsvData
}) => {
  const navigate = useNavigate();
  const reports = useSelector(state => state.reports);
  const additionalData = useSelector(state => state.reports.search.additionalData);
  const balanceDetails = ledgerDetailsConversion(additionalData?.balanceDetails);

  const dispatch = useDispatch();

  const getDraftIdFromOriginalEntries = (currentRow) => {
    
    dispatch(getDraftIdFromOriginalEntry(currentRow?.originalEntryId)).then((res) => {      
      navigate(`/precog-detail/${res}`, {state: {goBack: true}});
    }).catch(err => {

    });
  };

  // get details if not present in store
  useEffect(() => {// TODO remove this dispatch because I have it in header
    setSelectedSearch(true);
    document.querySelector("#dbx-main-container")?.scrollTo(0,0);// Scroll page on top
    const fromDate = paramsFromUrl["fromDate"] || reports.search.parameters.fromDate;
    const toDate = paramsFromUrl["toDate"] || reports.search.parameters.toDate;
    const accountId = paramsFromUrl["accountId"] || reports.search.parameters.accountId;
    if (!balanceDetails && accountId) {
      dispatch(getEntriesRead(
        accountId,
        "",
        fromDate,
        toDate
      ));
    }
    return () => {
      dispatch(clearEntriesParameters());
    };
  }, []);

  useEffect(() => {
    if (balanceDetails) {
      setDataReport(balanceDetails);
    }
  }, [balanceDetails]);

  useEffect(() => {
    setCsvData(balanceDetails && balanceDetails.rows ? balanceDetails.rows : []);
  }, [additionalData]);
  return (
    balanceDetails && balanceDetails.rows && (
      <div className="reports-balance-details-root">
        <div className="reports-balance-details-title">
          <div>
            Partitario del conto {paramsFromUrl["accountId"] || reports.search.parameters.accountId} - {" "}
            <span style={{ textTransform: "capitalize" }}>
              {additionalData?.balanceDetails?.accountTitle?.toLowerCase() || reports.search.parameters?.accountName?.toLowerCase() || paramsFromUrl.accountName?.toLowerCase()}
            </span>
          </div>
          <div>
            <span className="reports-balance-details-title-initialBalance">
              Saldo iniziale:{" "}
            </span>{" "}
            {numeral(additionalData?.balanceDetails?.initialBalance).format("0,0.00")} €
          </div>
        </div>
        <common.ReportCommonTable
          className={"balanceDetailsCustom"}
          report={balanceDetails}
          /** Devo gestire la action per aprire il dettaglio */
          goToDetails={getDraftIdFromOriginalEntries}
        />
      </div>
    )
  );
};

ReportLedgerSheet.propTypes = {
  objDetails: PropTypes.object.isRequired,
  setDataReport: PropTypes.func.isRequired,
  setSelectedSearch: PropTypes.func.isRequired
};

export default ReportLedgerSheet;
